import { useWidgetAlerts } from '@widgets/messenger/compositions/useWidgetAlerts'
import type { MessengerAlertScope } from '@widgets/messenger/types/alert'
import { computed, type MaybeRefOrGetter, toValue, watch } from '@/composition/vue/compositionApi'

type WidgetFormAlertParams = {
  commonErrors: MaybeRefOrGetter<string[]>
  scope: MaybeRefOrGetter<MessengerAlertScope>
}

export const useWidgetFormAlerts = ({ commonErrors, scope }: WidgetFormAlertParams) => {
  const commonErrorsRef = computed(() => toValue(commonErrors))
  const scopeRef = computed(() => toValue(scope))

  const { addAlert, removeAlert } = useWidgetAlerts([scopeRef.value])

  const getAlertId = () => {
    return `form-common-error-${scopeRef.value}`
  }

  const initCommonErrorsListening = () => {
    watch(commonErrorsRef, (value) => {
      if (value.length) {
        addAlert({
          id: getAlertId(),
          text: value.join('. '),
          scope: scopeRef.value,
        })
      } else {
        removeAlert(getAlertId())
      }
    })
  }

  return {
    initCommonErrorsListening,
  }
}
